"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./SingleSelect.style"));

var SingleSelect = react_1.forwardRef(function (_ref, _ref3) {
  var values = _ref.values,
      label = _ref.label,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      className = _ref.className,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      _ref$invalidCaption = _ref.invalidCaption,
      invalidCaption = _ref$invalidCaption === void 0 ? '' : _ref$invalidCaption;

  var _react_1$useState = react_1.useState(defaultValue),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      selectedValue = _react_1$useState2[0],
      setSelectedValue = _react_1$useState2[1];

  var inputRef = react_1.useRef(null);

  function handleToggle(_ref2) {
    var currentTarget = _ref2.currentTarget;
    setSelectedValue(currentTarget.innerText);
    onChange && onChange(currentTarget.innerText);

    if (inputRef.current !== null) {
      inputRef.current.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }

  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className
  }, {
    children: [label && jsx_runtime_1.jsx("label", Object.assign({
      css: styles.label
    }, {
      children: label
    }), void 0), jsx_runtime_1.jsx("input", {
      type: "hidden",
      ref: function ref(instance) {
        inputRef.current = instance;

        if (_ref3 !== null && typeof _ref3 === 'function') {
          _ref3(instance);
        }
      },
      css: styles.dataInput,
      value: selectedValue
    }, void 0), jsx_runtime_1.jsx("div", Object.assign({
      css: styles.container
    }, {
      children: values.map(function (value) {
        return jsx_runtime_1.jsx("button", Object.assign({
          type: "button",
          css: [styles.buttonWrapper, value === selectedValue && styles.selectedButton],
          onClick: handleToggle
        }, {
          children: value
        }), value);
      })
    }), void 0), invalid && invalidCaption && jsx_runtime_1.jsx("div", Object.assign({
      css: styles.invalidCaption
    }, {
      children: invalidCaption
    }), void 0)]
  }), void 0);
});
exports.default = react_1.memo(SingleSelect);